import { createSlice } from '@reduxjs/toolkit';

const uploadSlice = createSlice({
  name: 'upload',
  initialState: {
    progress: 0,
  },
  reducers: {
    updateProgress: (state, action) => {
      state.progress = action.payload;
    },
  },
});

export const { updateProgress } = uploadSlice.actions;
export default uploadSlice.reducer;